/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ModelProviderKey,
  ModelProviderKey$inboundSchema,
} from "./modelproviderkey.js";

export type ListKeysResponseBody = {
  /**
   * The model provider keys configured for the project.
   */
  keys: Array<ModelProviderKey>;
};

/** @internal */
export const ListKeysResponseBody$inboundSchema: z.ZodMiniType<
  ListKeysResponseBody,
  unknown
> = z.object({
  keys: z.array(ModelProviderKey$inboundSchema),
});

export function listKeysResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListKeysResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListKeysResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListKeysResponseBody' from JSON`,
  );
}
